module.exports = __webpack_public_path__ + "static/particle-5-8f7d90ed8b4e115ca1f420efe1cb56b5.png";